import { useEffect, useState } from 'react';
import { useParams, useSearchParams, Link, useLocation } from 'react-router-dom';
import dompurify from 'dompurify'

import Spinner from 'react-bootstrap/Spinner';

import Menu from '../../components/MenuBEA';
import Botao from '../../components/Botao';
import Especies from '../../components/EspeciesBEA';
import Podcasts from '../../components/Podcasts';
import Videos from '../../components/Videos';
import OutrasCertificacoes from '../../components/OutrasCertificacoes';
import CardEmpresaBea from '../../components/CardEmpresaBEA';
import TituloNegrito from '../../components/TituloNegrito';
import ProdutosCertificados from '../../components/ProdutosCertificadosBEA';
import Divisor from '../../components/Divisor';
import Idiomas from '../../components/Idiomas';
// import PontosDeVenda from '../../components/PontosDeVendaBEA'
import Contatos from '../../components/Contatos';
import Imagens from '../../components/Imagens';
import Noticias from '../../components/Noticias';

import constantes from '../../helpers/constanteHelper';
import { retornarTexto } from '../../helpers/textoHelper';
import { mostrarIdiomaEmpresa, validarTextoCondicionalPreenchido } from '../../helpers/idiomaHelper';

import sheetsService from '../../services/sheetsServiceBea'
import DetalhesCertificacaoBEA from '../../components/DetalhesCertificacaoBEA';


function DadosEmpresaBea() {
    const [width, setWidth] = useState(window.innerWidth);
    const [empresa, setEmpresa] = useState({})

    const sanitizer = dompurify.sanitize;

    const { slug } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();

    const location = useLocation()

    // Controle de idioma
    const [idioma, setIdioma] = useState(location?.state?.idioma ?? 'pt')

    // Controle de carregamento da tela
    const [telaCarregada, setTelaCarregada] = useState(false)

    function observarMudancaWidth() {
        setWidth(window.innerWidth);
    }

    function retornarDescricaoEmpresa(idioma) {
        return idioma === 'en' ? empresa['Descrição da empresa (Inglês)'] : idioma === 'es' ? empresa['Descrição da empresa (Espanhol)'] : empresa['Descrição da empresa']
    }

    function retornarSiteEmpresa(idioma) {
        if (idioma === 'en') {
            return empresa['Site da empresa (Inglês)'] ? empresa['Site da empresa (Inglês)'] : empresa['Site da empresa'] ? empresa['Site da empresa'] : undefined
        } else if (idioma === 'es') {
            return empresa['Site da empresa (Espanhol)'] ? empresa['Site da empresa (Espanhol)'] : empresa['Site da empresa'] ? empresa['Site da empresa'] : undefined
        } else {
            return empresa['Site da empresa'] ? empresa['Site da empresa'] : undefined
        }
    }

    function separarItensDesseIdioma(tipoItem) {
        return empresa[tipoItem]?.filter((item) => {
            if (idioma === 'pt') {
                return item['Português']?.toUpperCase() === 'X'
            } else if (idioma === 'en') {
                return item['Inglês']?.toUpperCase() === 'X'
            } else if (idioma === 'es') {
                return item['Espanhol']?.toUpperCase() === 'X'
            } else if (idioma === 'fr') {
                return item['Francês']?.toUpperCase() === 'X'
            }
        })
    }

    useEffect(() => {
        sheetsService.buscarDadosEmpresas().then((empresasBuscadas) => {
            for (let i = 0; i < empresasBuscadas.length; i++) {

                if (empresasBuscadas[i]['Slug (Url)'] === slug) {
                    setEmpresa(empresasBuscadas[i])
                    setTelaCarregada(true)
                }
            }

            // const veioDoBotaoPontosDeVenda = searchParams.get('pontos')
            // if (veioDoBotaoPontosDeVenda === 'true') {
            //     setTimeout(() => {
            //         document.getElementById('pontos')?.scrollIntoView()
            //     }, 200)
            // } else {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
            // }
        })

        window.addEventListener('resize', observarMudancaWidth);

        return () => {
            window.removeEventListener('resize', observarMudancaWidth);
        }
    }, []);

    const resolucaoMobile = width <= constantes.RESPONSIVIDADE.LARGURA_MOBILE;

    const regraExibicaoMenu = searchParams.get('menu')

    return (
        <>
            {telaCarregada ? <div style={{ padding: resolucaoMobile ? '0px 5px 0px 5px' : '0px', minHeight: '100vh', background: constantes.CORES.LARANJA_BEA }} className='text-center d-flex flex-column align-items-center'>
                {regraExibicaoMenu === 'false' ? <></> : <Menu opcaoSelecionada={'marcas'} />}

                <div className='mt-5'></div>
                <div className='mt-5'></div>

                <CardEmpresaBea resolucaoMobile={resolucaoMobile} empresa={empresa} desativarLink={regraExibicaoMenu === 'false'} idioma={idioma} />

                <div className='mt-5'></div>

                {mostrarIdiomaEmpresa(empresa) ? <Idiomas
                    idioma={idioma}
                    setIdioma={setIdioma}
                    resolucaoMobile={resolucaoMobile}
                    condicaoExibirIngles={validarTextoCondicionalPreenchido(empresa['Descrição da empresa (Inglês)'])}
                    condicaoExibirEspanhol={validarTextoCondicionalPreenchido(empresa['Descrição da empresa (Espanhol)'])}
                /> : <></>}

                <TituloNegrito texto={empresa['Empresa']} />

                <Especies item={empresa} resolucaoMobile={resolucaoMobile} idioma={idioma} />

                <div dangerouslySetInnerHTML={{ __html: sanitizer(retornarDescricaoEmpresa(idioma)) }} className='mt-5 mb-5' style={{ width: resolucaoMobile ? '90vw' : '70vw', color: constantes.CORES.BRANCO_PADRAO, fontSize: resolucaoMobile ? '16px' : '20px', whiteSpace: 'pre-line', textAlign: resolucaoMobile ? 'justify' : 'center', }}></div>

                {empresa['Site da empresa'] ? <Link className='mb-5' style={{ textDecoration: 'none' }} to={retornarSiteEmpresa(idioma)} target='_blank' rel='noopener noreferrer'>
                    <Botao cor={constantes.CORES.BRANCO_PADRAO} corTexto={constantes.CORES.LARANJA_BEA} largura={300} icone={'site'} texto={retornarTexto(idioma, 'acessarSiteDaEmpresa')} />
                </Link> : <></>}

                {empresa['Contatos'] && separarItensDesseIdioma('Contatos').length > 0 ? <>
                    <Divisor />
                    <Contatos contatos={separarItensDesseIdioma('Contatos')} resolucaoMobile={resolucaoMobile} idioma={idioma} /></> :
                    <></>}

                {regraExibicaoMenu ? <DetalhesCertificacaoBEA resolucaoMobile={resolucaoMobile} idioma={idioma} /> : <></>}

                <Divisor />

                {empresa['Produtos'] ? <ProdutosCertificados
                    resolucaoMobile={resolucaoMobile}
                    produtos={empresa['Produtos']}
                    exibirMenu={searchParams.get('menu') === 'false' ? false : true}
                    idioma={idioma}
                    slugEmpresa={empresa['Slug (Url)']}
                /> : <></>}

                {empresa['Vídeos'] ? <><Divisor />
                    <Videos item={empresa} resolucaoMobile={resolucaoMobile} idioma={idioma} /></>
                    : <></>}

                {empresa['Imagens'] && separarItensDesseIdioma('Imagens').length > 0 ? <>
                    <Divisor />
                    <Imagens imagens={separarItensDesseIdioma('Imagens')} resolucaoMobile={resolucaoMobile} idioma={idioma} /></> :
                    <></>
                }

                {empresa['Notícias'] && separarItensDesseIdioma('Notícias').length > 0 ? <>
                    <Divisor />
                    <Noticias noticias={separarItensDesseIdioma('Notícias')} resolucaoMobile={resolucaoMobile} idioma={idioma} /></> :
                    <></>
                }

                <OutrasCertificacoes item={empresa} resolucaoMobile={resolucaoMobile} idioma={idioma} />

                {/* <Divisor /> */}

                {/* <div id='pontos'>
                    <PontosDeVenda pontosDeVenda={empresa['Pontos de venda']} resolucaoMobile={resolucaoMobile} exibirMenu={searchParams.get('menu') === 'false' ? false : true} idioma={idioma} />
                </div> */}

            </div> : <div style={{ minHeight: '100vh', background: constantes.CORES.LARANJA_BEA }} className='d-flex flex-column align-items-center'>
                <div style={{ height: '100vh', gap: '20px' }} className='mt-5 d-flex flex-column align-items-center justify-content-center text-center'>
                    <Spinner style={{ height: '60px', width: '60px' }} variant='light' />
                    <span className='mt-3' style={{ fontSize: '20px', color: constantes.CORES.BRANCO_PADRAO, paddingLeft: '20px', paddingRight: '20px' }}>{retornarTexto(idioma, 'carregandoDadosParte1')}<br />{retornarTexto(idioma, 'carregandoDadosParte2')}</span>
                </div>
            </div>}
        </>
    );
}

export default DadosEmpresaBea;
